import { AppLayout } from 'layouts';
import { BookmarksFeed } from 'features/feed';
import { Sidebar } from 'features/sidebar';
import { useFeedbackOptions } from 'pages/hooks';

const PageBookmarks = () => {
  const feedbackOptions = useFeedbackOptions();

  return (
    <AppLayout aside={<Sidebar feedbackOptions={feedbackOptions} hideTodosFeedCta={false} />}>
      <BookmarksFeed />
    </AppLayout>
  );
};

export default PageBookmarks;
